export default __webpack_public_path__ + "static/media/18-01.1d818a8e.svg";